/**
 * viewerSurfacesAtom - Active surfaces for the current viewer route
 *
 * Surfaces declare what kind of work is happening on the page; the toolbar,
 * context menu, and help dialog filter their entries by the active set so
 * dictation users don't see segmentation tools and segmentation annotators
 * don't see the report editor shortcuts.
 *
 * `null` (default) = unfiltered — every entry shows. Pages that own a viewer
 * surface set this on mount and reset to null on unmount.
 */

import { atom } from "jotai";
import type { Surface } from "../constants/viewerActions";

export const viewerSurfacesAtom = atom<Surface[] | null>(null);
